import React from 'react';
import { Button, Dialog, DialogContent, DialogTitle, IconButton, Stack } from '@mui/material';
import { Pencil, X } from 'lucide-react';

import EventDetails from './EventDetails';
import EventParticipantsPanel from './EventParticipantsPanel';
import EventSharePanel from './EventSharePanel';

export default function EventDetailsDialog({ event, taskLinks = [], open, onClose, onEdit, onLeft }) {
  if (!event) return null;
  const creator = Boolean(event.permissions?.can_edit);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      PaperProps={{
        sx: (theme) => ({
          bgcolor: theme.palette.background.default,
          border: `3px solid ${theme.palette.green.main}`,
          borderRadius: 5,
          boxShadow: `0 0 28px ${theme.palette.green.main}44`,
        }),
      }}
    >
      <DialogTitle sx={{ display: 'flex', justifyContent: 'flex-end', p: 1 }}>
        <IconButton aria-label="Close event" onClick={onClose} sx={{ color: 'secondary.main' }}>
          <X />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ px: { xs: 1.5, sm: 2.5 }, pb: 3 }}>
        <Stack spacing={2.5}>
          <EventDetails event={event} taskLinks={taskLinks} />
          {creator && <EventSharePanel event={event} />}
          <EventParticipantsPanel event={event} onLeft={onLeft} />
          {creator && (
            <Button variant="outlined" startIcon={<Pencil size={17} />} onClick={onEdit} sx={{ color: 'primary.main' }}>
              Edit event
            </Button>
          )}
        </Stack>
      </DialogContent>
    </Dialog>
  );
}
